import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Contact founder block: photo, name, role, paragraph, and two CTAs (e.g. Calendly + email) with icons.
 * Used on Restaurants and Companies landings for "Contact Ilir".
 * @param {string} sectionTitle - Section heading (e.g. "Any questions?")
 * @param {string} image - Image src (founder photo)
 * @param {string} imageAlt - Alt text for the image
 * @param {string} name - Founder name
 * @param {string} role - Founder role (e.g. CEO)
 * @param {string} paragraph - Short friendly paragraph
 * @param {object} primaryCta - { url, label, icon }
 * @param {object} secondaryCta - { url, label, icon }
 */
function ContactFounder({
  sectionTitle,
  image,
  imageAlt,
  name,
  role,
  paragraph,
  primaryCta,
  secondaryCta,
}) {
  return (
    <section className="landing-section contact-founder">
      <div className="contact-founder__container">
        <h2 className="landing-section-title">{sectionTitle}</h2>
        <div className="contact-founder__card">
          <div className="contact-founder__avatar-wrapper">
            <img
              src={image}
              alt={imageAlt}
              className="contact-founder__avatar"
              loading="lazy"
            />
          </div>
          <div className="contact-founder__content">
            <div className="contact-founder__identity">
              <h3 className="contact-founder__name">{name}</h3>
              <span className="contact-founder__separator" aria-hidden="true">
                ·
              </span>
              <span className="contact-founder__role">{role}</span>
            </div>
            <p className="contact-founder__paragraph">{paragraph}</p>
            <div className="contact-founder__ctas">
              {primaryCta?.url && (
                <a
                  href={primaryCta.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-founder__cta contact-founder__cta--primary"
                  aria-label={primaryCta.label}
                >
                  <FontAwesomeIcon
                    icon={primaryCta.icon}
                    className="contact-founder__cta-icon"
                  />
                  <span>{primaryCta.label}</span>
                </a>
              )}
              {secondaryCta?.url && (
                <a
                  href={secondaryCta.url}
                  className="contact-founder__cta contact-founder__cta--secondary"
                  aria-label={secondaryCta.label}
                >
                  <FontAwesomeIcon
                    icon={secondaryCta.icon}
                    className="contact-founder__cta-icon"
                  />
                  <span>{secondaryCta.label}</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactFounder;
